module.exports = __webpack_public_path__ + "static/media/Logo_KC21-wide.7459a3a1.svg";